





































































































































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewWord extends Vue {
  @Prop() show!: any;
  @Prop() words!: any;
  @Prop() index!: any;
  @Prop() wordLevel!: any;
  @Prop() CategoryId!: any;
  copyWord = "";
  newSynonyms = "";
  newAntonyms = "";
  newExample = "";
  newFalseOption = "";
  tempWord = this.words;

  errors: any = [];
  @Emit("UpdateWords")
  UpdateWords() {
    return this.words;
  }
  @Emit("UpdateDayWord")
  UpdateDayWord() {
    return this.words;
  }
  @Emit("ModalClose")
  ModalClose() {
    this.words = this.tempWord;
    return this.show;
  }
  AddSynonym() {
    if (this.newSynonyms != "") {
      this.words[this.index].synonyms.push(this.newSynonyms);
    }
    this.newSynonyms = "";
  }
  AddAntonyms() {
    if (this.newAntonyms != "") {
      this.words[this.index].antonyms.push(this.newAntonyms);
    }
    this.newAntonyms = "";
  }
  RemoveAntonyms(anIndex: any) {
    this.$delete(this.words[this.index].antonyms, anIndex);
  }
  AddFalseOption() {
    if (this.newFalseOption != "") {
      this.words[this.index].mockFalseOptions.push(this.newFalseOption);
    }
    this.newFalseOption = "";
  }
  RemoveFalseOption(optIndex: any) {
    this.$delete(this.words[this.index].mockFalseOptions, optIndex);
  }
  RemoveSynonym(synIndex: any) {
    this.$delete(this.words[this.index].synonyms, synIndex);
  }
  AddExamples() {
    if (this.newExample != "") {
      this.words[this.index].examples.push(this.newExample);
    }
    this.newExample = "";
  }
  RemoveExamples(exIndex: any) {
    this.$delete(this.words[this.index].examples, exIndex);
  }

  checkRequired() {
    if (
      this.words[this.index].en &&
      this.words[this.index].bn &&
      this.words[this.index].partsOfSpeech
    ) {
      return true;
    }
    this.errors = [];
    if (!this.words[this.index].en) {
      this.errors.push("word required.");
    }
    if (!this.words[this.index].bn) {
      this.errors.push("bangla word required.");
    }
    if (!this.words[this.index].phBn) {
      this.errors.push("bangla phonetic  required.");
    }
    if (!this.words[this.index].partsOfSpeech) {
      this.errors.push("Parts Of Speech required.");
    }
  }
  AddNewWord() {
    if (this.checkRequired()) {
      this.updateField();
      if (this.$route.name == "main.word_of_the_day") {
        this.UpdateDayWord();
      } else this.UpdateWords();
      this.$emit("close");
    } else alert(false);
    // word.whoBn = word.whoEn = word.sentenceBn = word.sentenceEn = "";
  }
  partsOfSpeech = [
    "Noun",
    "Pronoun",
    "Verb",
    "Adjective",
    "Adverb",
    "Preposition",
    "Conjunction",
    "Interjenction",
  ];

  updateField() {
    this.words[this.index] = this.copyWord;
  }

  mounted() {
    const obj = this.words[this.index];
    this.copyWord = Object.assign({}, obj);
    // console.log("copy ", copy); // { a: 1 }
  }
}
